import { CommonService, ThemeService } from "services";
import { logger, modalNotification } from "utils";

export const CommonApi = {
  getState: async (queryParams) => {
    try {
      const res = await CommonService.stateService(queryParams);
      const { data, success } = res;
      if (success) {
        return data;
      }
    } catch (error) {
      logger(error);
    }
  },

  getCountry: async (queryParams) => {
    try {
      const res = await CommonService.countryService(queryParams);
      const { data, success } = res;
      if (success) {
        return data;
      }
    } catch (error) {
      logger(error);
    }
  },

  reportMemorial: async (bodyData) => {
    try {
      const res = await ThemeService.ReportMemorialService(bodyData);
      const { success, message } = res;
      if (success) {
        modalNotification({
          type: "success",
          message,
        });
      }
    } catch (err) {
      logger(err);
    }
  },

  saveUnSaveBiography: async (memorialId) => {
    try {
      const res = await ThemeService.saveUnSaveBiographyService(memorialId);
      const { success, message } = res;
      if (success) {
        modalNotification({
          type: "success",
          message,
        });
      }
    } catch (err) {
      logger(err);
    }
  },

  getFamilyTree: async (memorialId) => {
    try {
      const res = await ThemeService.getFamilyTreeService(memorialId);
      const { success, data } = res;
      if (data && success) {
        return data;
      }
    } catch (err) {
      logger(err);
    }
  },

  getPaternalTree: async (memorialId) => {
    try {
      const res = await ThemeService.getPaternalTreeService(memorialId);
      const { success, data } = res;
      if (data && success) {
        return data;
      }
    } catch (err) {
      logger(err);
    }
  },
};
